import { Link } from 'react-router';
import '../../styles/scheduled-meetings.css';

/** Scheduling is separate from the project's live audio rooms and conversation history. */
export function ProjectMeetings({ projectId }: { projectId: string }) {
  return <section className="project-scheduling" aria-label="Scheduled meetings">
    <div><h2>Scheduled meetings</h2><p className="muted">Plan a time, choose attendees and share a meeting entry link.</p></div>
    <Link to={`/p/${projectId}/scheduled-meetings`} className="btn">Schedule and manage meetings</Link>
  </section>;
}
